var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "btn btn-list-function", on: { click: _vm.click } },
    [
      _c("i", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.right.hover",
            value: _vm.tooltip,
            expression: "tooltip",
            modifiers: { right: true, hover: true }
          }
        ],
        staticClass: "fa m-b-5",
        class: _vm.isOn ? "fa-toggle-on" : "fa-toggle-off",
        attrs: { "aria-hidden": "true" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }